// Configuración centralizada de la API
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost',
  PORT: process.env.REACT_APP_API_PORT || '4000',
  
  getFullUrl: function() {
	  //validar si es puerto 80 para servidor en  produccion
	  if(this.PORT==='80'){
		  return `${this.BASE_URL}`;
	  }else{
		 return `${this.BASE_URL}:${this.PORT}`; 
	  }		  
  },
  // Endpoints de autenticación
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    VERIFY: '/api/auth/verify'
  },
  
  // Endpoints de usuarios
  USERS: {
    ALL: '/api/users',
    VENDEDORES: '/api/users/vendedores',
    REGIONES: '/api/users/regiones',
    JEFES: '/api/users/jefes',
    SUPERVISORES: '/api/users/supervisores',
    BY_ID: (id) => `/api/users/${id}`,
    SUPERVISOR: (id) => `/api/users/${id}/supervisor`
  },
  
  // Endpoints de ventas
  VENTAS: {
    ALL: '/api/ventas',
    TODAS: '/api/ventas/todas',
    RESUMEN: '/api/ventas/resumen',
    REPORTE: '/api/ventas/reporte',
    RECUPERAR: '/api/ventas/recuperar',
    BY_ID: (id) => `/api/ventas/${id}`,
    RECUPERAR_BY_ID: (id) => `/api/ventas/${id}/recuperar`
  },
  
  // Endpoints de productos
  PRODUCTOS: {
    ALL: '/api/productos',
    CATEGORIAS: '/api/productos/categorias',
    BY_ID: (id) => `/api/productos/${id}`
  },
  
  // Endpoints de clientes
  CLIENTES: {
    ALL: '/api/clientes',
    POTENCIALES: '/api/clientes/potenciales',
    ACTUALIZAR_POTENCIALES: '/api/clientes/potenciales/actualizar'
  },
  
  // Endpoints de colaboradores
  COLABORADORES: {
    ALL: '/api/colaboradores',
    REPORTE: '/api/colaboradores/reporte',
    BY_ID: (id) => `/api/colaboradores/${id}`,
    BAJA: (id) => `/api/colaboradores/${id}/baja`
  },
  
  // Endpoints de postulantes
  POSTULANTES: {
    ALL: '/api/postulantes',
    CONTACTAR: (id) => `/api/postulantes/${id}/contactar`,
    ENTREVISTAR: (id) => `/api/postulantes/${id}/entrevistar`
  },
  
  // Endpoints de ajustes
  AJUSTES: {
    EMPRESA: '/api/ajustes/empresa',
    TIPIFICACIONES: '/api/ajustes/tipificaciones',
    CATEGORIAS: '/api/ajustes/categorias',
    PERFILES: '/api/ajustes/perfiles',
    BY_TYPE: (type) => `/api/ajustes/${type}`,
    BY_TYPE_AND_ID: (type, id) => `/api/ajustes/${type}/${id}`
  },
  
  // Endpoints de calidad
  CALIDAD: {
    SEGUIMIENTO: '/api/calidad/seguimiento'
  },
  
  // Endpoints de ubicaciones
  LOCATIONS: {
    DEPARTMENTS: '/api/locations/departments',
    PROVINCES: (deptId) => `/api/locations/provinces/${deptId}`,
    DISTRICTS: (provId) => `/api/locations/districts/${provId}`
  },
  
  // Endpoints de logs
  LOGS: {
    MODIFICACIONES: '/api/log-modificaciones'
  },
  
  // Endpoints de dashboard
  DASHBOARD: {
    MAIN: '/api/dashboard'
  }
};

// Función helper para construir URLs completas
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.getFullUrl()}${endpoint}`;
};

// Función helper para obtener la URL base
export const getBaseUrl = () => {
  return API_CONFIG.getFullUrl();
};

// Función helper para obtener solo la URL sin puerto
export const getBaseUrlWithoutPort = () => {
  return API_CONFIG.BASE_URL;
};

// Función helper para obtener solo el puerto
export const getPort = () => {
  return API_CONFIG.PORT;
};

export default API_CONFIG; 